import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui-kit/button';
import { useNavigate, useSearchParams } from 'react-router-dom';
import emailSentIcon from '@/assets/images/verification-failed.svg';
import { useResendActivation } from '@/api-client/use-resend-activation';

export const VerificationFailed = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('userId') || '';

  const { ResendActivation, isPending } = useResendActivation();

  const handleResend = async () => {
    if (!userId) return;
    try {
      await ResendActivation({
        userId,
        mailPurpose: 'ResendActivation'
      });
      navigate('/'); // Go back to login or to a success page
    } catch (e) {
      // Error is handled globally or through toast if needed
    }
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="flex justify-center align-center">
        <div className="w-32 h-14 mb-20 ">
          <img src={emailSentIcon} alt="emailSentIcon" />
        </div>
      </div>

      <div>
        <div className="text-2xl font-bold text-high-emphasis mb-4">{t('VERIFICATION_FAILED')}</div>
        <div className="flex gap-1 mt-1">
          <div className="text-base font-normal text-medium-emphasis leading-6">
            {t('VERIFICATION_EMAIL_NO_LONGER_VALID')}
          </div>
        </div>
      </div>
      <Button
        className="font-extrabold"
        size="lg"
        type="button"
        onClick={handleResend}
        disabled={isPending || !userId}
      >
        {t('RESEND_LINK')}
      </Button>
      <Button
        className="font-extrabold text-primary -mt-2.5"
        size="lg"
        type="button"
        variant="ghost"
        onClick={() => navigate('/')}
      >
        {t('GO_TO_LOGIN')}
      </Button>
    </div>
  );
};
